/*
* @requires  ui-bootstrap.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {



})(HebcaMiddleware);
